<script lang="ts">
import { defineComponent } from 'vue';
import { formatCurrency, formatMoney } from '@/utils/format';

export default defineComponent({
  name: 'row-stake-amount',
  methods: { formatCurrency, formatMoney },
  props: ['stake'],
});
</script>

<template>
  <span class="text-lg font-bold">Ставка</span>
  <span class="text-lg font-bold">
    <span class="text-blue-600 dark:text-blue-400 font-bold font-mono">
      {{ formatMoney(+stake.stakeAmount) }}
    </span>
    {{ formatCurrency(+stake.stakeAmount, stake.currency) }}
  </span>
  <span class="text-lg font-bold">
    <span class="text-blue-600 dark:text-blue-400 font-bold">
      {{ formatMoney(+stake.vendorStakeAmount, 4, false) }}
    </span>
    {{ stake.vendorCurrency }}
  </span>
</template>

<style scoped lang="scss"></style>